export const DEFAULT_LANGUAGE = 'en';

const isObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const safeParse = (value) => {
    try {
        const parsedValue = JSON.parse(value);

        return isObject(parsedValue) ? parsedValue : null;
    } catch (error) {
        return null;
    }
};

const getWindowLanguagePayload = () => {
    if (typeof window === 'undefined' || !isObject(window.appLanguagePayload)) {
        return null;
    }

    return {
        key: normalizeLanguageKey(window.appLanguagePayload.key),
        translations: isObject(window.appLanguagePayload.translations)
            ? window.appLanguagePayload.translations
            : {},
    };
};

export const normalizeLanguageKey = (key) => {
    return typeof key === 'string' && key.trim()
        ? key.trim()
        : DEFAULT_LANGUAGE;
};

export const getStoredLanguageKey = () => {
    if (typeof window === 'undefined') {
        return DEFAULT_LANGUAGE;
    }

    return normalizeLanguageKey(
        window.localStorage.getItem('app-language')
        || window.appLanguage
        || getWindowLanguagePayload()?.key
        || DEFAULT_LANGUAGE
    );
};

export const getStoredTranslations = () => {
    if (typeof window === 'undefined') {
        return {};
    }

    return safeParse(window.localStorage.getItem('app-languages'))
        || getWindowLanguagePayload()?.translations
        || {};
};

export const persistLanguage = ({key, translations = {}} = {}) => {
    const resolvedKey = normalizeLanguageKey(key);
    const resolvedTranslations = isObject(translations) ? translations : {};

    if (typeof window !== 'undefined') {
        window.localStorage.setItem('app-language', resolvedKey);
        window.localStorage.setItem('app-languages', JSON.stringify(resolvedTranslations));
        window.appLanguage = resolvedKey;
        window.appLanguagePayload = {
            key: resolvedKey,
            translations: resolvedTranslations,
        };

        if (document?.documentElement) {
            document.documentElement.lang = resolvedKey;
        }
    }

    return {
        key: resolvedKey,
        translations: resolvedTranslations,
    };
};

export const ensureLanguagePersistence = () => {
    return persistLanguage({
        key: getStoredLanguageKey(),
        translations: getStoredTranslations(),
    });
};
